import { UNIVERSAL_ENV_VARS } from '../../constants/environmentVariables';
import { isProduction } from '../../helpers/environment/isProduction';
import { reportMykissClientError } from '../../helpers/errorHandling/client';
import { logger } from '../../helpers/logging';
import { JSON_HEADERS, post } from './shared';

export async function preSignupVerification(
  castleToken: string | undefined,
  email: string,
  status: 'attempted' | 'failed',
): Promise<void> {
  if (isProduction() || UNIVERSAL_ENV_VARS.FORCE_CASTLE_USAGE) {
    if (!castleToken) {
      logger.warn('No Castle token provided for pre-signup verification');
    } else {
      try {
        await post(
          encodeURI(`/user_verification/pre_sign_up`),
          async () => Promise.resolve(null),
          false,
          { castle_token: castleToken, email, status },
          JSON_HEADERS,
        );
      } catch (error) {
        logger.error('Error during pre-signup verification:', error);
        reportMykissClientError(error);
      }
    }
  }
}
